var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1499 646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2766_19201)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2766_19201)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 855.408,
    cy: 176.048,
    r: 1.01199,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.265,
    cy: 388.62,
    r: 1.09525,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.49,
    cy: 498.528,
    r: 0.909849,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 944.546,
    cy: 427.012,
    r: 0.771083,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.816,
    cy: 137.481,
    r: 1.4607,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.643,
    cy: 232.713,
    r: 1.43199,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614.742,
    cy: 205.692,
    r: 1.29245,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1272.33,
    cy: 186.502,
    r: 1.16262,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288.613,
    cy: 379.769,
    r: 1.17174,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.356,
    cy: 110.941,
    r: 1.10763,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.423,
    cy: 419.331,
    r: 1.11081,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.996,
    cy: 505.577,
    r: 0.853055,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.414,
    cy: 454.825,
    r: 1.19151,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 748.26,
    cy: 364.779,
    r: 1.15487,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.415,
    cy: 223.593,
    r: 1.30191,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 811.813,
    cy: 417.841,
    r: 0.84599,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 775.567,
    cy: 152.097,
    r: 1.01632,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 619.894,
    cy: 173.485,
    r: 0.815796,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1496.27,
    cy: 145.084,
    r: 0.854428,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.663,
    cy: 185.255,
    r: 1.12799,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 735.823,
    cy: 424.221,
    r: 1.3858,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731.094,
    cy: 87.871,
    r: 1.44724,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.865,
    cy: 212.082,
    r: 1.17899,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.501,
    cy: 307.551,
    r: 1.27227,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 813.324,
    cy: 152.128,
    r: 1.10744,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978.604,
    cy: 135.387,
    r: 1.32643,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1309.52,
    cy: 221.781,
    r: 1.01529,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.43,
    cy: 170.927,
    r: 0.777217,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.35,
    cy: 339.347,
    r: 1.23349,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1156.62,
    cy: 423.252,
    r: 1.45212,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1173.9,
    cy: 185.286,
    r: 1.23071,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.729,
    cy: 168.669,
    r: 1.01788,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.596,
    cy: 280.358,
    r: 0.912033,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.21,
    cy: 417.912,
    r: 1.32314,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.9191,
    cy: 232.579,
    r: 0.807741,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.41,
    cy: 303.118,
    r: 1.22507,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 943.1,
    cy: 491.272,
    r: 1.31302,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.78392,
    cy: 254.513,
    r: 0.942119,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 983.851,
    cy: 119.826,
    r: 0.862921,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.284,
    cy: 184.346,
    r: 0.885852,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 776.624,
    cy: 470.412,
    r: 1.04366,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.859,
    cy: 416.95,
    r: 1.24794,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.403,
    cy: 230.896,
    r: 1.4287,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 753.799,
    cy: 310.449,
    r: 1.20163,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.875,
    cy: 87.3222,
    r: 1.44122,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.6043,
    cy: 391.073,
    r: 1.16484,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1288.16,
    cy: 372.28,
    r: 1.48464,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1182.77,
    cy: 176.574,
    r: 1.08094,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.917,
    cy: 123.825,
    r: 1.29999,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1279.19,
    cy: 483.056,
    r: 0.758141,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.3806,
    cy: 349.971,
    r: 1.41381,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1109.34,
    cy: 106.222,
    r: 0.836492,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 93.4259,
    r: 1.02185,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1231.21,
    cy: 307.025,
    r: 0.950598,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.73,
    cy: 425.427,
    r: 1.30985,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.31,
    cy: 256.117,
    r: 1.41777,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.087,
    cy: 480.69,
    r: 1.07378,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.895,
    cy: 98.8738,
    r: 1.19005,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500.713,
    cy: 356.896,
    r: 1.0295,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.04677,
    cy: 410.744,
    r: 1.05067,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647.1,
    cy: 488.383,
    r: 0.930258,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.273,
    cy: 185.674,
    r: 1.31005,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 713.95,
    cy: 495.467,
    r: 0.993287,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 910.827,
    cy: 356.273,
    r: 1.32676,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 582.417,
    cy: 134.897,
    r: 1.41311,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.596,
    cy: 452.569,
    r: 0.914165,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1071.44,
    cy: 83.5331,
    r: 1.46641,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.039,
    cy: 250.58,
    r: 0.997832,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1319.02,
    cy: 74.5664,
    r: 0.850489,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 849.199,
    cy: 292.03,
    r: 1.15974,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.829,
    cy: 210.57,
    r: 1.12737,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1304.47,
    cy: 371.785,
    r: 1.14682,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.225,
    cy: 427.219,
    r: 1.01569,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 595.684,
    cy: 129.918,
    r: 0.756349,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 844.86,
    cy: 202.039,
    r: 1.42281,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.5913,
    cy: 451.334,
    r: 1.21625,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.216,
    cy: 177.369,
    r: 0.876334,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.28,
    cy: 519.509,
    r: 1.41136,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200.03,
    cy: 458.293,
    r: 0.895582,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1476.13,
    cy: 385.898,
    r: 1.06375,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794.71,
    cy: 436.434,
    r: 0.80986,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 683.234,
    cy: 277.156,
    r: 1.33129,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.62,
    cy: 218.558,
    r: 0.903532,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1045.65,
    cy: 285.026,
    r: 1.29495,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839.85,
    cy: 147.717,
    r: 0.879054,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.643,
    cy: 241.725,
    r: 1.13673,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.963,
    cy: 474.225,
    r: 1.18963,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976.643,
    cy: 338.794,
    r: 0.83624,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.537,
    cy: 509.496,
    r: 1.05494,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1436.03,
    cy: 278.396,
    r: 0.935043,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 937.18,
    cy: 478.004,
    r: 1.40301,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1053.69,
    cy: 427.405,
    r: 0.895225,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.087,
    cy: 353.011,
    r: 1.44024,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395.93,
    cy: 322.604,
    r: 0.943416,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1385.76,
    cy: 127.537,
    r: 1.14912,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1234.64,
    cy: 487.152,
    r: 1.13036,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1250.06,
    cy: 102.538,
    r: 1.34681,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.7779,
    cy: 292.003,
    r: 0.875573,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1325.2,
    cy: 355.264,
    r: 0.940735,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.593,
    cy: 75.8219,
    r: 1.14921,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794.023,
    cy: 206.411,
    r: 1.34731,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1325.59,
    cy: 457.776,
    r: 1.13547,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.711,
    cy: 101.959,
    r: 1.08251,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898.312,
    cy: 97.4118,
    r: 1.41354,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.844,
    cy: 155.798,
    r: 1.2837,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 662.759,
    cy: 379.91,
    r: 1.37856,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 592.699,
    cy: 247.301,
    r: 0.785391,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.8359,
    cy: 319.89,
    r: 0.841746,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.517,
    cy: 440.919,
    r: 1.05847,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.8826,
    cy: 100.486,
    r: 1.35723,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 598.222,
    cy: 164.667,
    r: 1.26064,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1354.39,
    cy: 486.707,
    r: 1.45196,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1261.98,
    cy: 344.999,
    r: 1.4663,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.064,
    cy: 295.517,
    r: 0.886333,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.811,
    cy: 91.7361,
    r: 1.49871,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1309.51,
    cy: 509.298,
    r: 1.15663,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 710.815,
    cy: 477.363,
    r: 0.84625,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 588.715,
    cy: 442.774,
    r: 1.11716,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1111.3,
    cy: 454.392,
    r: 1.48561,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.6577,
    cy: 392.528,
    r: 1.16747,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5392,
    cy: 91.9376,
    r: 1.11535,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.558,
    cy: 78.5427,
    r: 0.997906,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1262.69,
    cy: 146.603,
    r: 1.35229,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.061,
    cy: 425.091,
    r: 1.11388,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1312.7,
    cy: 196.943,
    r: 1.22071,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578.039,
    cy: 173.452,
    r: 1.40592,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.248,
    cy: 207.601,
    r: 1.00626,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.27,
    cy: 423.286,
    r: 1.38923,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.444,
    cy: 365.216,
    r: 1.1201,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.846,
    cy: 293.04,
    r: 1.26756,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1027.91,
    cy: 347.775,
    r: 0.79822,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.897,
    cy: 114.404,
    r: 0.82076,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.87,
    cy: 221.416,
    r: 1.21027,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.044,
    cy: 282.434,
    r: 1.08908,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1443.09,
    cy: 166.811,
    r: 1.06951,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.771,
    cy: 368.031,
    r: 1.22557,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1136.29,
    cy: 520.336,
    r: 1.12102,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1126.55,
    cy: 205.554,
    r: 0.920028,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1369.46,
    cy: 516.007,
    r: 1.41113,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.734,
    cy: 356.688,
    r: 1.48745,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1369.67,
    cy: 172.481,
    r: 1.24753,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1190.89,
    cy: 103.317,
    r: 0.927353,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.296,
    cy: 412.829,
    r: 1.23886,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533.576,
    cy: 193.066,
    r: 1.37686,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 644.238,
    cy: 286.059,
    r: 1.2573,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.837,
    cy: 432.885,
    r: 0.81193,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1225.73,
    cy: 385.511,
    r: 1.32581,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494.799,
    cy: 496.218,
    r: 0.870935,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.36,
    cy: 290.408,
    r: 1.10208,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 683.028,
    cy: 213.836,
    r: 0.95369,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 765.732,
    cy: 326.691,
    r: 1.1309,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.184,
    cy: 442.297,
    r: 1.39294,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 742.043,
    cy: 367.503,
    r: 1.43951,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1441.54,
    cy: 446.555,
    r: 1.21012,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1498.65,
    cy: 502.014,
    r: 1.24817,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.147,
    cy: 336.209,
    r: 1.1763,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1408.53,
    cy: 81.7512,
    r: 0.82413,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.375,
    cy: 102.353,
    r: 1.14601,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240.62,
    cy: 134.609,
    r: 0.879705,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1226.32,
    cy: 277.602,
    r: 1.17607,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.514,
    cy: 453.18,
    r: 0.785148,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.47,
    cy: 195.938,
    r: 1.47438,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.021,
    cy: 525.435,
    r: 0.898173,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 869.321,
    cy: 140.203,
    r: 1.17621,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.021,
    cy: 208.962,
    r: 0.759128,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.199,
    cy: 404.299,
    r: 0.754085,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.839,
    cy: 337.018,
    r: 1.09246,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1085.56,
    cy: 307.274,
    r: 1.35072,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.198,
    cy: 416.736,
    r: 1.14357,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586.993,
    cy: 323.683,
    r: 0.957927,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1297.39,
    cy: 520.966,
    r: 0.901406,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1298.26,
    cy: 396.403,
    r: 1.45338,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.188,
    cy: 182.112,
    r: 0.942399,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.022,
    cy: 258.433,
    r: 0.96538,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.491,
    cy: 323.403,
    r: 0.80773,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.759,
    cy: 229.14,
    r: 1.05539,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.594,
    cy: 114.981,
    r: 1.35392,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.931,
    cy: 406.243,
    r: 1.09514,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 843.764,
    cy: 360.242,
    r: 1.28906,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.427,
    cy: 447.858,
    r: 0.995575,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1422.73,
    cy: 523.621,
    r: 1.07437,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.86,
    cy: 125.774,
    r: 1.01083,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 821.03,
    cy: 78.9125,
    r: 0.795235,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1307.25,
    cy: 129.985,
    r: 0.776141,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.047,
    cy: 438.948,
    r: 0.961254,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.499,
    cy: 151.559,
    r: 1.18449,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.629,
    cy: 486.06,
    r: 1.37299,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.1744,
    cy: 246.563,
    r: 0.820878,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.508,
    cy: 99.6769,
    r: 1.38712,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.604,
    cy: 438.942,
    r: 1.23266,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170.15,
    cy: 387.047,
    r: 1.12536,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.419,
    cy: 146.386,
    r: 0.861929,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1035.05,
    cy: 344,
    r: 0.980915,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 389.703,
    r: 1.35959,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 961.035,
    cy: 114.324,
    r: 1.46862,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.4113,
    cy: 270.088,
    r: 0.829266,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761.07,
    cy: 168.192,
    r: 1.44154,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1145.16,
    cy: 124.54,
    r: 1.09556,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.0996,
    cy: 338.543,
    r: 1.29105,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.82,
    cy: 108.457,
    r: 1.32941,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 603.368,
    cy: 320.556,
    r: 0.947807,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095.27,
    cy: 292.72,
    r: 1.17783,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.108,
    cy: 351.77,
    r: 0.820537,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871.717,
    cy: 224.714,
    r: 0.951524,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1258.47,
    cy: 177.888,
    r: 1.29186,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1081.92,
    cy: 412.984,
    r: 1.04498,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.68,
    cy: 308.318,
    r: 1.41485,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.744,
    cy: 236.535,
    r: 1.10717,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1476.39,
    cy: 365.499,
    r: 1.33914,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 795.736,
    cy: 137.47,
    r: 1.42725,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1425.37,
    cy: 154.711,
    r: 1.20128,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.031,
    cy: 247.892,
    r: 1.10948,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.949,
    cy: 327.546,
    r: 0.802637,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1356.36,
    cy: 105.462,
    r: 1.38983,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1088.54,
    cy: 278.059,
    r: 1.49782,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.986,
    cy: 293.226,
    r: 1.27858,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.077,
    cy: 397.61,
    r: 0.8308,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975.774,
    cy: 305.312,
    r: 1.15335,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.109,
    cy: 150.224,
    r: 1.32564,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.538,
    cy: 258.576,
    r: 0.79947,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 785.858,
    cy: 83.9694,
    r: 0.887497,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1470.56,
    cy: 163.249,
    r: 1.40498,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1217.31,
    cy: 296.201,
    r: 0.827926,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1471.25,
    cy: 108.231,
    r: 1.47646,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 677.633,
    cy: 470.117,
    r: 1.29748,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5638,
    cy: 236.564,
    r: 1.02475,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.6886,
    cy: 304.141,
    r: 0.878051,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.7812,
    cy: 285.478,
    r: 0.753897,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1412.83,
    cy: 511.736,
    r: 1.17429,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.09,
    cy: 103.02,
    r: 1.14553,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1200.82,
    cy: 439.121,
    r: 1.25676,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.774,
    cy: 72.7717,
    r: 1.21912,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1385.5,
    cy: 86.9231,
    r: 0.889207,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.526,
    cy: 307.293,
    r: 1.43025,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 617.206,
    cy: 260.607,
    r: 0.779834,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.033,
    cy: 323.204,
    r: 0.769764,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 667.217,
    cy: 443.533,
    r: 0.967313,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.613,
    cy: 519.901,
    r: 0.919405,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.259,
    cy: 71.7934,
    r: 1.00521,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.997,
    cy: 85.2912,
    r: 1.32709,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1137.81,
    cy: 359.732,
    r: 1.01731,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640.999,
    cy: 321.697,
    r: 1.31915,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1445.09,
    cy: 378.691,
    r: 1.13798,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.917,
    cy: 420.234,
    r: 1.19627,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5584,
    cy: 300.78,
    r: 1.36894,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.825,
    cy: 365.8,
    r: 1.26237,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.134,
    cy: 121.81,
    r: 1.0692,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.171,
    cy: 107.645,
    r: 0.810002,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.633,
    cy: 417.644,
    r: 1.23425,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1240.7,
    cy: 210.965,
    r: 0.892874,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1289.93,
    cy: 312.549,
    r: 1.39725,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1352.92,
    cy: 483.593,
    r: 1.07213,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1065.67,
    cy: 262.695,
    r: 1.05633,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.142,
    cy: 386.784,
    r: 0.916996,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540.313,
    cy: 111.881,
    r: 1.13508,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.579,
    cy: 468.581,
    r: 1.09311,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1214.48,
    cy: 72.1073,
    r: 1.28458,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1238.09,
    cy: 171.136,
    r: 1.36588,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.699,
    cy: 297.296,
    r: 0.828144,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181.04,
    cy: 497.377,
    r: 1.19963,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.356,
    cy: 368.853,
    r: 0.945935,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.688,
    cy: 76.7322,
    r: 1.33026,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.555,
    cy: 516.204,
    r: 0.959316,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.2555,
    cy: 341.959,
    r: 1.19695,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.325,
    cy: 343.949,
    r: 1.40705,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.6221,
    cy: 515.07,
    r: 1.15922,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.797,
    cy: 177.055,
    r: 1.3633,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1319.79,
    cy: 478.876,
    r: 0.856094,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.3552,
    cy: 325.148,
    r: 0.972422,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1090.26,
    cy: 485.503,
    r: 1.45803,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.377,
    cy: 321.74,
    r: 1.41651,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1270.95,
    cy: 237.983,
    r: 1.41698,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900.05,
    cy: 320.777,
    r: 0.989282,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1384.61,
    cy: 498.178,
    r: 1.42554,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906.714,
    cy: 416.931,
    r: 1.08682,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 589.889,
    cy: 329.523,
    r: 1.08416,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1143.96,
    cy: 194.085,
    r: 1.40979,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.552,
    cy: 519.943,
    r: 1.49332,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8206,
    cy: 491.452,
    r: 1.06674,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1197.77,
    cy: 285.347,
    r: 1.05668,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.235,
    cy: 206.565,
    r: 0.832496,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.597,
    cy: 77.9402,
    r: 1.07547,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.712,
    cy: 518.842,
    r: 1.28432,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1442.36,
    cy: 341.114,
    r: 1.23557,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.4682,
    cy: 419.892,
    r: 0.864702,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004.05,
    cy: 224.88,
    r: 1.04819,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 901.987,
    cy: 297.902,
    r: 1.04936,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.828,
    cy: 509.787,
    r: 1.17153,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 726.064,
    cy: 197.824,
    r: 1.31586,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1102.34,
    cy: 84.8827,
    r: 1.33431,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652.502,
    cy: 345.842,
    r: 0.810172,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.09,
    cy: 92.2137,
    r: 1.42549,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.795,
    cy: 349.8,
    r: 1.21842,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.917,
    cy: 242.542,
    r: 1.30933,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.071,
    cy: 346.163,
    r: 0.953558,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1138.86,
    cy: 158.728,
    r: 1.42258,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1353.94,
    cy: 225.477,
    r: 1.1448,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1268.86,
    cy: 273.654,
    r: 1.40016,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1132.41,
    cy: 399.155,
    r: 1.17653,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 731.135,
    cy: 121.027,
    r: 1.23631,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.04,
    cy: 370.212,
    r: 0.889902,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0783,
    cy: 133.138,
    r: 0.933805,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.793,
    cy: 370.15,
    r: 1.11556,
    fill: "#333333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_2766_19201)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 749,
    cy: 126.562,
    rx: 287,
    ry: 116.594,
    fill: "url(#paint0_linear_2766_19201)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2766_19201",
    x: 59.8707,
    y: -392.161,
    width: 1378.26,
    height: 1037.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 201.065,
    result: "effect1_foregroundBlur_2766_19201"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2766_19201",
    x1: 572.886,
    y1: 84.9801,
    x2: 815.858,
    y2: 160.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A72B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2766_19201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1499,
    height: 455,
    fill: "white",
    transform: "translate(0 70)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2766_19201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1499,
    height: 1499,
    fill: "white",
    transform: "translate(0 70)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBg);
export default __webpack_public_path__ + "static/media/aboutBg.37acd3120b5bdb16b434c2c89b9b4e97.svg";
export { ForwardRef as ReactComponent };